var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('component-tip',{attrs:{"content":_vm.content}},[_c('date-picker',_vm._g(_vm._b({},'date-picker',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }